import { createEmptyLogsAndVars, dwReportError, recordVariable } from "../diagnostics/clientErrors";
export const toStorageJson = (data) => {
    const json = JSON.stringify(data);
    return json;
};
export const fromStorageJson = (json) => {
    try {
        return JSON.parse(json);
    }
    catch (ex) {
        const logsAndVars = createEmptyLogsAndVars("storageJsonConvert:fromStorageJson");
        recordVariable(logsAndVars, "json (param)", json);
        dwReportError(null, undefined, ex, { logsAndVars });
        return undefined;
    }
};
export const fromStorageJsonDecrypt = (json) => {
    const logsAndVars = createEmptyLogsAndVars("storageJsonConvert:fromStorageJsonDecrypt");
    recordVariable(logsAndVars, "json (ProfileData param)", json);
    try {
        const contextValue = {
            name: json.name,
            email: json.email,
            twofa: json.twofa,
            emailnotification: json.emailnotification,
            profilevisibility: json.profilevisibility,
            datasharing: json.datasharing,
            isDarkmode: json.isDarkmode,
            isLoginnotifications: json.isLoginnotifications,
            isBalance: json.isBalance,
            nillionUserKey: json.nillionUserKey,
        };
        recordVariable(logsAndVars, "contextValue", contextValue);
        return contextValue;
    }
    catch (ex) {
        dwReportError(null, undefined, ex, { logsAndVars });
        return undefined;
    }
};
export const createEmptyStorageJson = () => {
    return createStorageJson("", "", false, false, false, false, false, false, false);
};
export const createStorageJson = (name, email, twofa, emailnotification, profilevisibility, datasharing, isDarkmode, isLoginnotifications, isBalance) => {
    const profileData = {
        name: name,
        email: email,
        twofa: twofa,
        emailnotification: emailnotification,
        profilevisibility: profilevisibility,
        datasharing: datasharing,
        isDarkmode: isDarkmode,
        isLoginnotifications: isLoginnotifications,
        isBalance: isBalance,
    };
    return profileData;
};
